import { Save } from "lucide-react";
import { Button } from "../ui/button";
import { DialogClose } from "../ui/dialog";

const SaveButton = ({
	disabled,
	isDialog = false,
}: {
	disabled?: boolean;
	isDialog?: boolean;
}) => {
	const button = (
		<Button
			disabled={disabled}
			size="lg"
			type="submit"
			data-testid="save-button"
			className="group flex justify-center items-center gap-2 w-full transition-all duration-300"
		>
			Save
			<Save className="w-4 h-4 group-hover:rotate-[8deg] transition-all duration-500 ease-out-back" />
		</Button>
	);

	if (isDialog) {
		return <DialogClose asChild>{button}</DialogClose>;
	}
	return button;
};

export default SaveButton;
